import { iPost } from './posts';

export enum iPromotionType {
    advert = 'advert',
    event = 'event',
    job = 'job',
    offer = 'offer',
}

export enum iPromotionTier {
    bronze = 'bronze',
    silver = 'silver',
    gold = 'gold',
    platinum = 'platinum',
}

export interface iPromotion extends iPost {
    settings: {
        company_name: string,
        promotion_type: iPromotionType;
    };
    tier: iPromotionTier,
    total_claimed: number;
    type: 'promotion';
}
